import React, { Component } from 'react';
import styles from './styles';
import { css } from 'aphrodite';

class Title extends Component {

    render() {
        const className = css(
            styles.title,
            this.props.style,
            this.props.reverse && styles.reverse,
            this.props.separator && styles.separator
        );
        return (
            <h3
                className={className}
                dangerouslySetInnerHTML={{__html: this.props.children}}
            ></h3>
        );
    }
}

export default Title;